
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { injectModels } from "../../redux/injectModels";
import { login } from "../../redux/Models/Auth/action";
import { AuthService } from "../../services";
import { handleConsoleError } from "../../utils/common-methods";
import { globalConstant } from "../../constants/globalConstant";

const UpdateEmail = ({props, setSubmitHandler,onEmailChangeSuccess }) => {
      const loginUser = AuthService.getLoginUser();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      password: "",    
      newEmail: "",
      email:loginUser?.email??"",
    },
  });

 
  const onSubmit = async (data) => {
   // console.log("Updating email with data:", data);

    // Example API call
    try {
       props.application.setLoading(true);
      const response = await AuthService.emailChangeRequest(data);
        if (response?.isSuccess) {
      toast.success(response?.message);
      reset(); // clear form
        props.application.setLoading(false);
        onEmailChangeSuccess();
        }
        else{
           toast.error(response?.message||"Something went wrong");
           props.application.setLoading(false);
        }
    } catch (err) {
        props.application.setLoading(false);
        const message= handleConsoleError(err);
      toast.error(err?.message || message);
    }
  };

  // register submit function to parent
  useEffect(() => {
    setSubmitHandler(() => handleSubmit(onSubmit));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Form>
<div >

     {/*  <p> <b>IMPORTANT:</b> Use your new email to log in after confirming it. A confirmation email has been sent to your new address</p> */}
      <p style={{fontSize:"16px"}}> <b>IMPORTANT:</b> Your email change will only be applied after confirmation via the link sent to your new email address.If you log out before confirming, the confirmation link may expire and you may need to request a new one.</p>
      </div>
       
        {/* <div className="mb-3"><p><b>Current Email : </b>{" "}{loginUser?.email}</p></div> */}
       
    
       <Form.Group className="mb-3" controlId="newEmail">
        <Form.Label>New Email</Form.Label>
        <Form.Control
          type="email"
          maxLength={80}
          {...register("newEmail", {
            required: "Email is required",
            pattern: {
              value:
                globalConstant.emailRegex,
              message: "Invalid Email",
            },
          })}
          placeholder="new email"
        />
        {errors.newEmail && (
          <span className="text-danger">{errors.newEmail.message}</span>
        )}
      </Form.Group>
      <Form.Group className="mb-3" controlId="password">
        <Form.Label>Password </Form.Label>
        <Form.Control
          type="password"
          maxLength={20}
          {...register("password", { required: "Password is required" })}
          placeholder="password"
        />
        {errors.password && (
          <span className="text-danger">{errors.password.message}</span>
        )}
      </Form.Group>

     
    </Form>
  );
};

export default injectModels(["application"])(UpdateEmail);